import React, { useEffect, useRef, useState } from "react";

import UserProfileImageList from "../components/UserProfileImageList";

import arrowDown from "../../../assets/icons/arrow-down.png";
import arrowUp from "../../../assets/icons/arrow-up.png";
import trash from "../../../assets/icons/trash.png";
import { FilterTag } from "../AvailableAudienceItem";

export default function AudienceItem({ scrollValue, audience, onDelete }) {
  const [showFilters, setShowFilters] = useState(false);
  const [filterPosition, setFilterPosition] = useState({ top: 0, left: 0 });
  const filtersRef = useRef(null);

  const audiencePatients = [
    { first_name: "Jim" },
    { first_name: "John" },
    { first_name: "Kevin" },
    { first_name: "Amanda" },
    { first_name: "Arman" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
    { first_name: "Mohammad" },
  ];

  // Updating the position of the filters while togeeling and scrolling
  useEffect(
    function () {
      if (!filtersRef.current || !showFilters) return;

      const rect = filtersRef.current.getBoundingClientRect();

      // After teting multiple times, i found out that 45 and 360 are the proper values to position the element correctly.
      setFilterPosition({ top: rect.top + 45, left: rect.left - 161 });
    },
    [showFilters, scrollValue]
  );

  return (
    <div
      style={{
        padding: "10px 20px",
        backgroundColor: "white",
        border: "1px solid #E0DDF7",
        borderRadius: 10,
        display: "flex",
        flexDirection: "column",
        gap: 15,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 14, color: "#6B43B5", textTransform: "capitalize", }}>{audience.title}</span>
        <img src={trash} alt="trash" style={{width: 16, height: 16, cursor: 'pointer'}} onClick={() => onDelete(audience.id)}/>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative" }}>
        <span style={{ fontSize: 12 }}>Total Filters</span>

        <span style={{ padding: "3px 15px", color: "#6B43B5", backgroundColor: "#EEEDFA", borderRadius: 100, fontSize: 12 }} ref={filtersRef}>
          {audience.criteria_count} Filters{" "}
          <img
            src={showFilters ? arrowDown : arrowUp}
            alt="arrow-up"
            style={{ width: 15, cursor: "pointer" }}
            onClick={() => setShowFilters((show) => !show)}
          />
        </span>

        {showFilters && (
          <div
            style={{
              position: "fixed",
              top: `${filterPosition.top}px`,
              left: `${filterPosition.left}px`,
              borderRadius: 10,
              width: 270,
              maxWidth: 370,
              marginTop: "-15px",
              marginLeft: "-10px",
              padding: "10px",
              backgroundColor: "white",
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.15)",
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              zIndex: 100,
            }}
            className="custom-scroll"
          >
            {audience.criteria_details.map((item) =>  <FilterTag key={item} item={item}/> )}
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <span style={{ fontSize: 12 }}>Total Patients</span>

        <div style={{ display: "flex", alignItems: "center" }}>
          {audiencePatients.slice(0, 6).map((patient, index) => (
            <UserProfileImageList index={index} text={patient.first_name.charAt(0)} totalPatients={audiencePatients.length} />
          ))}
        </div>
      </div>
    </div>
  );
}
